import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'

const app = createApp(App)
const pinia = createPinia()
app.use(router)
app.use(pinia)
import axios from 'axios'

//5分钟验证一次，减轻服务端压力
let validToken = false
let lastTime = 0
const VERIFY_INTERVAL = 5 * 60 * 1000

router.beforeEach(async (to, from, next) => {
    //如果是公开路由，直接放行
    const publicRoutes = ['/login', '/register']
    if(publicRoutes.includes(to.path)){
        next()
        return
    }

    //调用后端接口的参数1，转成int类型
    const userid = localStorage.getItem("userid")
    const userId = parseInt(userid, 10)
    //从localStorage获得token，参数2
    const token = localStorage.getItem("token")

    //如果两个参数有一个为空，直接跳转登录界面
    if(userid == null || token == null){
        next("/login")
        return
    }

    const now = Date.now();
    if(validToken && now - lastTime < VERIFY_INTERVAL){
        //如果上次验证时间不足5分钟,并且上次的验证为true,则放行
        //很可惜，防不了刷新，刷新的话照样需要重新验证
        next()
        return
    }

    //否则去后端验证
    const success = await axios.get("http://gateway-internal.haoxiangchijiji2778.top/store/vertifytoken", {
        params: {
            userId: userId,
            token: token
        }
    })//然后设置上次验证时间以及上次验证结果
    validToken = success.data
    lastTime = now
    console.log(success.data)

    //成功了就放行，否则去登录界面
    if (success.data) {
        next()
    } else {
        alert('请先登录！')
        localStorage.removeItem("userid")
        localStorage.removeItem("token")
        next('/login')
    }
})
app.mount('#app')